import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import {Observable, shareReplay} from 'rxjs';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {TranslateService, TranslatePipe} from '@ngx-translate/core';
import {ErrorHandlingService} from '../../shared/service/error-handling/error-handling.service';
import {ErrorInfo} from '../../shared/model/error-info';
import {InformationService} from '../../shared/service/information/information.service';
import {SearchResult} from '../../shared/model/search-result';
import {AsyncPipe, DatePipe} from '@angular/common';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {ErrorBoxComponent} from '../error-box/error-box.component';
import {MatIcon} from '@angular/material/icon';
import {MatCard} from '@angular/material/card';
import {SearchSlotComponent} from '../search-slot/search-slot.component';
import {AdobeTrackingService} from '@datev/ngx-adobe-tracking';
import {tap} from 'rxjs/operators';

import '@datev/dacks/content';
import '@datev/dacks/content-header';
import { FooterSpacing } from "../footer/footer-spacing";

@Component({
    selector: 'myupdates-search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [SearchSlotComponent, MatCard, RouterLink, MatIcon, ErrorBoxComponent, MatProgressSpinner,
    AsyncPipe, DatePipe, TranslatePipe, FooterSpacing]
})
export class SearchResultComponent implements OnInit {

  errorInfo$: Observable<ErrorInfo>;
  searchResult$?: Observable<SearchResult>;
  searchTerm = '';
  dateTranslation = '';
  isQueryTooShort = false;

  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router,
              private readonly adobeTrackingService: AdobeTrackingService,
              private readonly errorHandlingService: ErrorHandlingService,
              private readonly informationService: InformationService,
              private readonly translate: TranslateService) {
    this.errorInfo$ = this.errorHandlingService.errorStream$;
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.searchTerm = params['query'];
        this.adobeTrackingService.publishSearchStartedEvent(this.searchTerm);
        this.searchResult$ = this.getInformation(this.searchTerm).pipe(
          tap(result => this.adobeTrackingService.publishSearchFinishedEvent(result.hits.length)),
          shareReplay(1)
        );
      });
    this.dateTranslation = this.translate.instant('common.date_format');
  }

  getInformation(query: string): Observable<SearchResult> {
    const result = this.informationService.getInformationBySearchQuery(query);
    this.isQueryTooShort = this.informationService.isQueryTooShort();

    return this.errorHandlingService.bindErrorHandling(result);
  }

}
